<template>
	<div>
		<v-dialog v-model="isOpenCoverageAvatel" persistent max-width="1400px">
			<v-stepper v-model="e1">
				<v-stepper-header>
					<v-stepper-step :complete="e1 > 1" step="1">
						Introducir dirección
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step :complete="e1 > 2" step="2">
						Previsualización mapa
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="3">
						Resultados cobertura
					</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="1" class="pt-0 px-0">
						<v-progress-linear
							v-if="isLoadingCoverageAvatel"
							indeterminate
							color="primary"
						></v-progress-linear>
						<v-card elevation="0" class="px-6">
							<v-card-text class="py-4">
								<v-form
									class="pa-2"
									ref="form"
									v-model="valid"
									lazy-validation
								>
									<v-row>
										<v-col cols="12" md="11">
											<v-row dense>
												<!-- <v-col cols="12" md="5">
													<v-card
														class="px-2"
														outlined
													>
														<v-row
															align-self="center"
														>
															<v-col
																cols="12"
																md="12"
															>
																<v-text-field
																	v-model="
																		form.provincia
																	"
																	label="Provincia"
																	required
																	:rules="
																		provinciaRules
																	"
																	prepend-icon="mdi-city"
																></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col> -->
												<v-col cols="12" md="2">
													<v-card
														class="px-2"
														outlined
													>
														<v-row
															align-self="center"
														>
															<v-col
																cols="12"
																md="12"
															>
																<v-text-field
																	v-model="
																		form.cp
																	"
																	label="Código postal"
																	required
																	type="number"
																	@blur="
																		cpBlur
																	"
																	@focus="
																		cpFocused
																	"
																	prepend-icon="mdi-post"
																	:error-messages="
																		cpErrors
																	"
																></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" md="4">
													<v-card
														outlined
														class="px-2"
													>
														<v-row>
															<v-col
																cols="12"
																md="12"
															>
																<v-combobox
																	v-model="
																		form.localidad
																	"
																	:items="
																		inferredLocalidades
																	"
																	:menu-props="
																		localidadMenuProps
																	"
																	label="Localidad"
																	:error-messages="
																		localidadErrors
																	"
																	@blur="
																		$v.form.localidad.$touch();
																		closeLocalidadMenu();
																	"
																	prepend-icon="mdi-city"
																	@click:item="
																		closeLocalidadMenu
																	"
																>
																	<template
																		v-slot:item="{
																			item,
																		}"
																	>
																		<div
																			@click="
																				closeLocalidadMenu
																			"
																		>
																			{{
																				item
																			}}
																		</div>
																	</template>
																</v-combobox>
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" md="3">
													<v-card
														class="px-2"
														outlined
													>
														<v-row
															align-self="center"
														>
															<v-col
																cols="12"
																md="12"
															>
																<v-text-field
																	v-model="
																		form.lat
																	"
																	label="Latitud"
																	required
																	type="number"
																	@blur="
																		$v.form.lat.$touch()
																	"
																	:error-messages="
																		latitudErrors
																	"
																	prepend-icon="mdi-map-marker"
																></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" md="3">
													<v-card
														class="px-2"
														outlined
													>
														<v-row
															align-self="center"
														>
															<v-col
																cols="12"
																md="12"
															>
																<v-text-field
																	v-model="
																		form.lng
																	"
																	label="Longitud"
																	required
																	type="number"
																	@blur="
																		$v.form.lng.$touch()
																	"
																	:error-messages="
																		longitudErrors
																	"
																	prepend-icon="mdi-map-marker"
																></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>
											</v-row>

											<v-row dense>
												<v-col cols="12" md="12">
													<v-card
														outlined
														class="px-2"
													>
														<v-row>
															<v-col
																cols="12"
																md="12"
															>
																<v-text-field
																	v-model="
																		form.direccion
																	"
																	label="Dirección"
																	required
																	@blur="
																		$v.form.direccion.$touch()
																	"
																	:error-messages="
																		direccionErrors
																	"
																	prepend-icon="mdi-home-automation"
																></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>
											</v-row>
										</v-col>
										<v-col
											cols="12"
											md="1"
											align="center"
											align-self="center"
										>
											<v-btn
												:loading="
													isLoadingCoverageAvatel
												"
												:disabled="!valid"
												fab
												depressed
												dark
												:color="
													valid ? 'indigo' : 'grey'
												"
												@click="dispathGeoCodingAvatel"
											>
												<v-icon large
													>mdi-magnify</v-icon
												>
											</v-btn>
										</v-col>
									</v-row>
								</v-form>
							</v-card-text>
							<div class="d-flex justify-md-end">
								<v-btn
									text
									color="red"
									@click="closeDialog"
									class="mr-2"
								>
									Cancelar
								</v-btn>

								<v-btn
									color="warning"
									:disabled="isLoadingCoverageAvatel"
									class="mr-4"
									@click="reset"
								>
									Limpiar campos
								</v-btn>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-card v-if="e1 == 2">
							<v-card-text>
								<MapBoxView
									:geoLatLng="[form.lng, form.lat]"
									@changeCoordinates="handledCoordinates"
								/>
							</v-card-text>
							<div class="d-flex justify-md-end">
								<v-btn
									text
									color="red"
									@click="closeDialog"
									class="mr-2"
								>
									Cancelar
								</v-btn>

								<v-btn
									class="mr-2"
									color="warning"
									dark
									@click="e1 = 1"
								>
									Volver
								</v-btn>

								<v-btn
									color="primary"
									:disabled="isLoadingCoverageAvatel"
									class="mr-4"
									@click="dispatchCoverageAvatel"
								>
									<v-progress-circular
										v-if="isLoadingCoverageAvatel"
										indeterminate
									></v-progress-circular>
									<span v-else>Verificar cobertura</span>
								</v-btn>
							</div>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="3">
						<div class="text-center overline">
							<v-icon>mdi-home-map-marker</v-icon>
							{{ completeDirection }}
							<div>
								<v-icon>mdi-map-marker-radius</v-icon>
								{{
									completeLatLong
										? `[${completeLatLong.lat}, ${completeLatLong.lng}]`
										: ''
								}}
							</div>
						</div>
						<v-card
							v-if="e1 == 3 && coverageDataAvatel"
							elevation="0"
							:class="
								$vuetify.breakpoint.xs
									? 'd-flex justify-center flex-wrap my-5 mx-2'
									: 'd-flex justify-center flex-wrap my-5 mx-2'
							"
						>
							<!-- Huella propia -->
							<v-card class="ma-4" elevation="4" width="300px">
								<v-card-title
									primary-title
									class="d-flex justify-center py-2"
									style="background-color: #c1c1c1"
								>
									<img
										:src="`/avatel-coverage.png`"
										alt="avatel"
										height="30"
									/>
								</v-card-title>
								<div class="text-center overline">
									<v-icon size="20"> mdi-fingerprint </v-icon>
									HUELLA PROPIA
								</div>
								<!-- <v-divider class="test"></v-divider> -->
								<v-card-text class="pt-0">
									<div
										class="
											font-weight-normal
											pa-4
											text-center
										"
									>
										<div
											:class="
												isCoverageAvatel
													? 'green--text'
													: 'red--text'
											"
										>
											{{
												getInfoCoverageAvatel[
													'coverage'
												]
											}}
										</div>
										<div>
											{{
												getInfoCoverageAvatel[
													'coverageType'
												]
											}}
										</div>
										<div>
											{{
												getInfoCoverageAvatel[
													'namingZone'
												]
											}}
										</div>
										<div>
											{{
												getInfoCoverageAvatel[
													'distance'
												]
											}}
										</div>
									</div>
								</v-card-text>
							</v-card>
							<!-- Huella externa -->
							<v-card class="ma-4" elevation="4" width="300px">
								<v-card-title
									primary-title
									class="d-flex justify-center py-2"
									style="background-color: #c1c1c1"
								>
									<img
										:src="`/externa-coverage.png`"
										alt="externa"
										height="30"
									/>
								</v-card-title>
								<div class="text-center overline">
									<v-icon size="20">
										mdi-fingerprint-off
									</v-icon>
									HUELLA EXTERNA
								</div>
								<!-- <v-divider class="test"></v-divider> -->
								<v-card-text class="pt-0">
									<div
										class="
											font-weight-normal
											pa-4
											text-center
										"
									>
										<div
											:class="
												isCoverageExterna
													? 'green--text'
													: 'red--text'
											"
										>
											{{
												getInfoCoverageExterna[
													'coverage'
												]
											}}
										</div>
										<div>
											{{
												getInfoCoverageExterna[
													'coverageType'
												]
											}}
										</div>
										<div
											v-for="(
												coverage, index
											) in getInfoCoverageExterna.dataExterna"
											:key="index"
										>
											<div>
												{{ coverage['operator'] }}
											</div>
											<div>
												{{ coverage['buildingId'] }}
											</div>
										</div>
									</div>
								</v-card-text>
							</v-card>
							<MapBoxView
								v-if="completeLatLong && getInfoCoverageAvatel"
								:geoLatLng="[
									completeLatLong.lng,
									completeLatLong.lat,
								]"
								:coverageGeometry="getInfoCoverageAvatel.theGeometry"
								@changeCoordinates="handledCoordinates"
							/>
						</v-card>
						<v-col cols="12" sm="4" class="ml-auto pa-0">
							<div
								:class="
									$vuetify.breakpoint.smAndDown
										? 'd-block'
										: 'd-flex justify-end'
								"
							>
								<v-btn
									depressed
									:width="
										$vuetify.breakpoint.smAndDown
											? '100%'
											: ''
									"
									:class="
										$vuetify.breakpoint.smAndDown
											? 'mb-1'
											: ''
									"
									color="warning"
									dark
									@click="e1 = 2"
								>
									Volver
								</v-btn>
								<v-btn
									depressed
									text
									color="primary"
									:width="
										$vuetify.breakpoint.smAndDown
											? '100%'
											: ''
									"
									:class="
										$vuetify.breakpoint.smAndDown
											? 'mb-2'
											: ''
									"
									@click="cleanAndReset"
								>
									Consultar otra dirección
								</v-btn>
								<v-btn
									depressed
									text
									color="red"
									:width="
										$vuetify.breakpoint.smAndDown
											? '100%'
											: ''
									"
									:class="
										$vuetify.breakpoint.smAndDown
											? 'mb-2'
											: ''
									"
									@click="closeDialog"
								>
									cerrar
								</v-btn>
							</div>
						</v-col>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-dialog>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import { maxLength, minLength, requiredIf } from 'vuelidate/lib/validators';
import {
	localidadErrors,
	cpErrors,
	direccionErrors,
	latitudErrors,
	longitudErrors,
} from './errorHandlers';

// Components import
import MapBoxView from './MapBoxView.vue';

export default {
	name: 'CoverageAvatelView',
	components: {
		MapBoxView,
	},
	data: () => ({
		e1: 1,
		inferredLocalidades: [],
		localidadMenuProps: {
			value: false,
			// openOnClick: true,
			// closeOnClick: true,
			// closeOnContentClick: true,
		},
		isCPFocused: false,
		valid: false,
		selectAddress: null,
	}),
	validations() {
		let validLatAndLongRegex = /^-?\d{1,3}\.\d{1,20}$/;
		let validLatSpain = () => {
			if (!this.form.lat) {
				return true;
			}

			if (!validLatAndLongRegex.test(this.form.lat)) {
				return false;
			}

			return this.form.lat >= 27.5 && this.form.lat <= 43.8;
		};

		let validLongSpain = () => {
			if (!this.form.long) {
				return true;
			}

			if (!validLatAndLongRegex.test(this.form.lng)) {
				return false;
			}

			return this.form.lng >= -18.5 && this.form.lng <= 4.5;
		};

		let requireIfLatAndLong = () => {
			return !this.form.lat && !this.form.lng;
		};

		let requiredIfLoCpDir = () => {
			return (
				!this.form.localidad && !this.form.cp && !this.form.direccion
			);
		};

		let form = {
			localidad: {
				requiredIf: requiredIf(requireIfLatAndLong),
			},
			cp: {
				requiredIf: requiredIf(requireIfLatAndLong),
				min: minLength(5),
				max: maxLength(5),
			},
			direccion: {
				requiredIf: requiredIf(requireIfLatAndLong),
			},
			lat: {
				requiredIf: requiredIf(requiredIfLoCpDir),
				validLatSpain,
			},
			lng: {
				requiredIf: requiredIf(requiredIfLoCpDir),
				validLongSpain,
			},
		};

		return {
			form,
		};
	},
	methods: {
		handledCoordinates(event) {
			this.form.lat = event.lat;
			this.form.lng = event.lng;
		},
		closeLocalidadMenu() {
			// console.log('close')
			this.localidadMenuProps = JSON.parse(
				JSON.stringify(this.localidadMenuProps)
			);
			this.localidadMenuProps.value = false;
		},
		cpBlur(val) {
			this.isCPFocused = false;
			this.$v.form.cp.$touch();
		},
		cpFocused(val) {
			this.isCPFocused = true;
		},
		closeDialog() {
			this.$store.commit('coverageAvatel/isOpenCoverageAvatel', false);
			setTimeout(() => {
				this.cleanAndReset();
			}, 200);
		},
		cleanAndReset() {
			this.e1 = 1;
			this.reset();
			this.$store.commit('coverageAvatel/resetCoverageAvatelData');
		},
		dispathGeoCodingAvatel() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.$store.dispatch('util/showStatusSnackBar', {
					statusType: 'error',
					message: 'Hay un error en los campos',
				});
			} else {
				this.$v.$reset();
				if (!this.form.lat || !this.form.lng) {
					this.$store.commit(
						'coverageAvatel/isLoadingCoverageAvatel',
						true
					);
					this.consultGeoCodingAvatel(this.form).then((resp) => {
						let { lat, lng } = resp.data;
						this.form.lat = lat;
						this.form.lng = lng;
						this.$store.commit(
							'coverageAvatel/isLoadingCoverageAvatel',
							false
						);
						this.e1 = 2;
					});
				} else {
					this.e1 = 2;
				}
			}
		},
		dispatchCoverageAvatel() {
			this.$store.commit('coverageAvatel/isLoadingCoverageAvatel', true);
			this.consultCoverageAvatel({
				lat: this.form.lat,
				lng: this.form.lng,
			}).then(() => {
				this.$store.commit(
					'coverageAvatel/isLoadingCoverageAvatel',
					false
				);
				this.e1 = 3;
			});
		},
		reset() {
			this.$refs.form.reset();
		},
		...mapActions('coverageAvatel', [
			'consultCoverageAvatel',
			'consultGeoCodingAvatel',
		]),
	},
	computed: {
		localidadErrors,
		cpErrors,
		direccionErrors,
		latitudErrors,
		longitudErrors,
		getInfoCoverageAvatel() {
			if (
				this.coverageDataAvatel &&
				this.coverageDataAvatel.avatel &&
				this.coverageDataAvatel.avatel.status == 'OK'
			) {
				const coverageAvatel = this.coverageDataAvatel.avatel;

				return {
					coverage: `${coverageAvatel.servicio}`,
					namingZone: `${coverageAvatel.zonas[0].zona}, ${coverageAvatel.zonas[0].name}`,
					distance: coverageAvatel.distancia,
					coverageType: coverageAvatel.zonas[0].tipo,
					theGeometry: JSON.parse(coverageAvatel.zonas[0].the_geom),
				};
			}
			return {};
		},
		isCoverageAvatel() {
			return this.getInfoCoverageAvatel['coverage'] == 'CON COBERTURA';
		},
		getInfoCoverageExterna() {
			if (
				this.coverageDataAvatel &&
				this.coverageDataAvatel.externa &&
				this.coverageDataAvatel.externa.data
			) {
				const coverageExterna = this.coverageDataAvatel.externa;

				const dataExterna = coverageExterna.data.map((obj) => {
					return {
						operator: obj.operator,
						buildingId: obj.building_id,
					};
				});

				return {
					coverage: `${
						coverageExterna.code == 0 ? 'SIN' : 'CON'
					} COBERTURA`,
					dataExterna: dataExterna,
					coverageType: 'FTTH',
				};
			}
			return {};
		},
		isCoverageExterna() {
			return this.getInfoCoverageExterna['coverage'] == 'CON COBERTURA';
		},
		completeDirection() {
			return this.coverageDataAvatel &&
				this.coverageDataAvatel.geocode &&
				this.coverageDataAvatel.geocode.status == 'OK'
				? `${this.coverageDataAvatel.geocode.results[0].formatted_address}`
				: '';
		},
		completeLatLong() {
			return this.coverageDataAvatel &&
				this.coverageDataAvatel.geocode &&
				this.coverageDataAvatel.geocode.status == 'OK'
				? {
						lat: this.coverageDataAvatel.geocode.results[0].geometry
							.location.lat,
						lng: this.coverageDataAvatel.geocode.results[0].geometry
							.location.lng,
				  }
				: {};
		},
		form: {
			get: function () {
				return this.$store.state.coverageAvatel.coverageAvatel.form;
			},
			set: function (val) {
				this.$store.commit('coverageAvatel/coverageForm', val);
			},
		},
		isOpenCoverage: {
			get: function () {
				return this.$store.state.coverage.coverage.isOpenCoverage;
			},
			set: function (val) {
				this.$store.commit('coverageAvatel/isOpenCoverageAvatel', val);
			},
		},
		...mapState('coverageAvatel', {
			coverageDataAvatel: (state) =>
				state.coverageAvatel.coverageDataAvatel,
			isLoadingCoverageAvatel: (state) =>
				state.coverageAvatel.isLoadingCoverageAvatel,
			isOpenCoverageAvatel: (state) =>
				state.coverageAvatel.isOpenCoverageAvatel,
		}),
	},
	watch: {
		'form.cp': function (val) {
			if (this.form.cp && this.form.cp.length == 5 && this.isCPFocused) {
				// console.log('aaomaeua')
				// console.log(this.$v)
				axios
					.get(
						this.$store.getters['teletrabajo/LocalidadEndpoint'] +
							this.form.cp
					)
					.then((response) => {
						this.inferredLocalidades =
							response.data.map(({ nombre }) => nombre) ?? [];
						this.localidadMenuProps.value = true;
						this.form.localidad = '';
						// this.localidadMenuProps = JSON.parse(JSON.stringify(this.localidadMenuProps))
					});
			}
		},
	},
};
</script>
<style scoped>
.test {
	border-width: 1px !important;
	border-color: #e0e0e0 !important;
	height: 100%;
}
</style>